import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MegaMenuModule } from 'primeng/megamenu';
import {TabMenuModule} from 'primeng/tabmenu';
import { MenubarModule } from 'primeng/menubar';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { CardModule } from 'primeng/card';
import { ToastModule } from 'primeng/toast';

import { TableModule } from 'primeng/table';
import { CalendarModule } from 'primeng/calendar';
import { SliderModule } from 'primeng/slider';
import { MultiSelectModule } from 'primeng/multiselect';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { ProgressBarModule } from 'primeng/progressbar';
import { AvatarModule } from 'primeng/avatar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CheckboxModule } from 'primeng/checkbox';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ChartModule } from 'primeng/chart';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import {DataViewModule} from 'primeng/dataview';

@NgModule({
  imports: [
    CommonModule,
    MegaMenuModule,
    TabMenuModule,
    MenubarModule,
    ButtonModule,
    InputTextModule,
    PasswordModule,
    CardModule,
    ToastModule,
    TableModule,
    CalendarModule,
    SliderModule,
    MultiSelectModule,
    ContextMenuModule,
    DialogModule,
    DropdownModule,
    ProgressBarModule,
    AvatarModule,
    ConfirmDialogModule,
    CheckboxModule,
    InputSwitchModule,
    InputTextareaModule,
    ChartModule,
    ProgressSpinnerModule,
    DataViewModule,
  ],
  exports: [
    MegaMenuModule,
    TabMenuModule,
    MenubarModule,
    ButtonModule,
    InputTextModule,
    PasswordModule,
    CardModule,
    ToastModule,
    TableModule,
    CalendarModule,
    SliderModule,
    MultiSelectModule,
    ContextMenuModule,
    DialogModule,
    DropdownModule,
    ProgressBarModule,
    AvatarModule,
    ConfirmDialogModule,
    CheckboxModule,
    InputSwitchModule,
    InputTextareaModule,
    ChartModule,
    ProgressSpinnerModule,
    DataViewModule,
  ],
  providers: [],
  declarations: []
})
export class SharedModule { }
